import { useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { FormatValueDecimal, CurrencyConvertion } from "../../utils/Validate";
import { buildColorChargeRows, normaliseColorCode } from "../../utils/colorCharges";

const SpecialColorDetailsModal = ({ show, onHide, values, currencyDetail }) => {
const specialColorRows = useMemo(() => {
        const rowsWithArea = buildColorChargeRows(values);
        if (rowsWithArea.length > 0) return rowsWithArea;

        return (Array.isArray(values?.colorCharges) ? values.colorCharges : [])
            .map((charge) => ({
                ...charge,
                colorCode: normaliseColorCode(charge?.colorCode ?? charge?.ralColorCode),
                chargeAmount: charge?.amountInDefaultCurrency ?? charge?.chargeAmount ??
                    charge?.amount ?? charge?.remainingAmount ?? 0,
            }))
            .filter((charge) => charge.colorCode);
    }, [values]);
    const hasSurfaceArea = specialColorRows.some((row) =>
        row.knownAreaSquareMetres !== null && row.knownAreaSquareMetres !== undefined
    );

    const formatSurfaceArea = (value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? `${FormatValueDecimal(numericValue)} m²` : "0 m²";
    };

    const formatCharge = (value) => {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue) || numericValue <= 0) return "-";
        //currency conversion
        return FormatValueDecimal(CurrencyConvertion(numericValue, values?.conversionRate, currencyDetail));
    };

    return (
        <Modal size="lg" show={show} onHide={onHide} className="special-color-modal-popup drawer right-align">
            <Modal.Header>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="mb-0">Special Color</h5>
                    <i className="fas fa-times" onClick={onHide}></i>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>RAL Color Code</th>
                                {hasSurfaceArea && <th>Total Surface Area (m²)</th>}
                                <th>Charges ({currencyDetail?.shortCode})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {specialColorRows.length > 0 ? specialColorRows.map((row, index) => (
                                <tr key={row.colorCode || index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {row.colorCode || "Unassigned"}
                                    </td>
                                    {hasSurfaceArea && (
                                        <td>{row.knownAreaSquareMetres === null || row.knownAreaSquareMetres === undefined ? "Pending calculation" : formatSurfaceArea(row.knownAreaSquareMetres)}</td>
                                    )}
                                    <td className="text-right">{formatCharge(row.chargeAmount)}</td>
                                </tr>
                            )) : (
                                <tr><td colSpan={hasSurfaceArea ? 4 : 3} className="text-center">No special color details available</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SpecialColorDetailsModal;
